import InputCustom from "@ui/inputs/InputCustom";
import {useTranslation} from "react-i18next";

const FileName = ({exportParams}) => {

    const{t} = useTranslation()

    const {fileName, setFileName} = exportParams;

    return (
        <InputCustom
            fullWidth
            size={'small'}
            label={t('fileName')}
            value={fileName}
            onChange={setFileName}/>
    );
};

export default FileName;